
export const ACA_CAMPAIGN_TYPE = 'aca-health-insurance'
export const ACA_CAMPAIGN_NAME = 'ACA Health Insurance'
